import { getSentry } from './sentry';

/**
 * Send exception to Sentry
 * @param ex
 * @param message
 */
const logException = (ex, message, reportError = true) => {
  console.error(ex, message);
  if (reportError) {
    const Sentry = getSentry();
    if (Sentry) {
      const errors = ex?.data?.errors;
      const extra = {
        message,
        errors,
      };

      Sentry.captureException(ex, {
        extra,
      });
    }
  }
};

/**
 * Send Axios error to Sentry
 * @param error
 */
const logAxiosError = ({ config, message, request, response }) => {
  let reportError = true;
  const url = config?.url;
  const errorInfo = {
    config,
    url,
  };

  if (response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    errorInfo.data = response.data;
    errorInfo.status = response.status;
    errorInfo.headers = response.headers;

    // Don't report error to Sentry if this is a 401 as it occurs often under normal conditions
    // ie when refresh token is invalid
    if (response.status === 401) reportError = false;
  } else if (request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    errorInfo.request = request;
  } else {
    // Something happened in setting up the request that triggered an Error
    errorInfo.message = message;
  }

  logException(
    new Error(`An error making XHR request to ${url}`),
    errorInfo,
    reportError
  );
};

export { logAxiosError, logException };
